module.exports = __webpack_public_path__ + "imgs/instagram2.6671d91682e28f94577b85548d4c5e40.svg";